import bankCopecPay from '../../banksPNG/bankCopecPay.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoCopecPayIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Copec',
}: IconProps) => <img src={bankCopecPay} width={width} height={height} alt={alt} />;
